import Mark from "./Mark.ts";
import MarkText from "../components/MarkText.ts";
import {Container, Graphics, Sprite, Text} from "pixi.js";
import IMark from "../interfaces/IMark.ts";
import RhColors from "@/models/RhColors.ts";

export default class VoicedVoicelessMark extends Mark implements IMark
{
    private code:string;

    public get targetX():number
    {
        if(this._targetX == undefined)
        {
            if(this.targetTextField)
            {
                this._targetX = 0;
            }
            else
            {
                this._targetX = 0;
            }
        }
        return this._targetX;
    }

    public get targetY():number
    {
        if(this._targetY == undefined)
        {
            if(this.targetTextField)
            {
                this._targetY = this.targetTextField.y;
            }
            else
            {
                this._targetY = 0;
            }
        }
        return this._targetY;
    }

    constructor(targetTextField?:MarkText, code:string="~", color=RhColors.MARK_PRIMARY)
    {
        super(color);
        this.targetTextField = targetTextField;
        this.code = code;
        this._init();
    }

    private _init():void
    {
        this.markWidth = 85;
        this.markHeight = 25;
        if(this.targetTextField)
        {
            this.targetTextFieldStyle = this.targetTextField.style;
            this.strokeThickness = Number(this.targetTextFieldStyle.fontSize)/20;
            this.padding = this.adjustToScale(6)*this.multipleOfDefaultFontSize;
            this.parentTarget = this.targetTextField;
            this.markY = this.targetTextField.height/2 + this.adjustToScale(104)*this.multipleOfDefaultFontSize;
        }
    }

    private createMark(color:string=this.color, visible:boolean=true):Graphics | Sprite | Text | Container
    {
        this.markWidth -= this.padding*2;
        const blendWidth = this.markWidth-(this.padding*2);
        let blendHeight = 30;
        let mark = new Graphics();
        if (this.code === "~") {
            mark.moveTo(16, 0);
            for (let hzz: number = 0; hzz <= 6; hzz++) {
                mark.lineTo(hzz * ((blendWidth - 32) / 6) + 16, hzz % 2 * 10);
            }
            blendHeight = 32;
        } else {
            mark.moveTo(20, 2);
            mark.lineTo(blendWidth - (20+(this.padding/2)), 5);
        }

        mark.moveTo(0, 5);
        mark.quadraticCurveTo(blendWidth / 10, blendHeight, blendWidth / 2, blendHeight);
        mark.quadraticCurveTo(blendWidth - (blendWidth / 10), blendHeight, blendWidth, 5);
        mark.stroke({width:this.strokeThickness, color:color, cap:"round"});
        mark.visible = visible;
        this.addChild(mark);
        //mark.cacheAsBitmap = true;
        return mark;
    }

    public override create():void
    {
        this.createMarks();
    }

    public createMarks():void
    {
        this.mark = this.createMark();
        this.markHighlight = this.createMark(this.highlightColor, false);
    }

}